import { render, staticRenderFns } from "./lotto-config.vue?vue&type=template&id=9a4afb80&"
import script from "./lotto-config.vue?vue&type=script&lang=js&"
export * from "./lotto-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports